import * as firebase from "firebase/app";
import { useEffect, useState } from "react";

interface UseDocumentHook<T> {
  value?: T;
  error?: Error;
  loading: boolean;
  update(partial: Partial<T>): Promise<void>;
  replace(content: object): Promise<void>;
}

export const useDocument = <T>(path: string): UseDocumentHook<T> => {
  const [value, setValue] = useState<T | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | undefined>(undefined);
  const ref = firebase.firestore().doc(path);
  useEffect(() => {
    return ref.onSnapshot(snapshot => {
      setLoading(false);
      setValue(snapshot.data() as T);
    }, setError);
  }, [path]);
  return {
    error,
    value,
    loading,
    async update(partial: Partial<T>): Promise<void> {
      await ref.set(partial, { merge: true });
    },
    async replace(content: object): Promise<void> {
      await ref.set(content);
    }
  };
};
